import { AsyncPipe, CommonModule, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SiteContextComponentService, SiteContextType } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { concatMap, switchMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { LanguageExtendService } from 'src/app/service/language/language-extend.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import {
  COUNTRY_FLAG_INSTEAD,
  FLAG_ICON,
  MyaccountFeaturesConfigService,
} from 'src/app/service/myaccount/myaccount-features-config.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';

@Component({
  selector: 'app-language-flag',
  templateUrl: './language-flag.component.html',
  styleUrls: ['./language-flag.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
   providers: [SiteContextComponentService],
    standalone: true,
  imports: [CommonModule,
    MatIconModule,
    NgbDropdownModule],
})
export class LanguageFlagComponent implements OnInit {
  @Input() context: SiteContextType;
  activeLanguageData$: any;
  languageItems: any;
  lang$: Observable<any>;
  shimanoActiveLanguageData: any;
  shimanoActiveLanguageCountryIsocode: string;
  shimanoActiveLanguageIsocode: string;

  availableLanguages: any;
  availableLanguages$: Observable<any>;

  isUserLoggedIn = false;
  previousUrl: any;

  activeCountry$: Observable<string> = this.countryService.getActive();

  isLanguageFlagIconEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, FLAG_ICON)
    )
  );

  isCountryFlagInsteadEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, COUNTRY_FLAG_INSTEAD)
    )
  );

  constructor(
    private languageService: ShimanoLanguageService,
    private languageExtendService: LanguageExtendService,
    private cdr: ChangeDetectorRef,
    private componentService: ComponentService,
    private countryService: ShimanoCountryService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    const selectedLanguageOnLogin = this.storageService.getLocalStorageItem('selectedLanguageOnLogin');
    const asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
    if (selectedLanguageOnLogin && !asmEnabled) {
      this.setShimanoActiveLanguage(selectedLanguageOnLogin, true);
    } else {
      this.getShimanoActiveLanguage();
    }
  }

  setShimanoActiveLanguage(language: string, fromLogin = false) {
    this.languageExtendService
      .setShimanoActiveLanguage(language)
      .pipe(
        take(1),
        concatMap(() => {
          this.languageService.setActive(language);
          return this.languageExtendService.getShimanoActiveLanguage();
        }),
        concatMap((activeLanguage) => {
          this.shimanoActiveLanguageData = activeLanguage.language;
          this.shimanoActiveLanguageCountryIsocode = activeLanguage.language.country.isocode;
          this.shimanoActiveLanguageIsocode = activeLanguage.language.isocode;
          return this.languageExtendService.getAvailableLanguages();
        })
      )
      .subscribe((availableLanguages) => {
        this.availableLanguages = availableLanguages.languages;
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
        if (fromLogin) {
          this.storageService.removeLocalStorageItem('selectedLanguageOnLogin');
          this.componentService.isPageLoadedFromLogin$.next(true);
        }
      });
  }

  getShimanoActiveLanguage() {
    this.languageExtendService
      .getShimanoActiveLanguage()
      .pipe(
        concatMap((activeLanguage) => {
          this.languageService.setActive(activeLanguage.language.isocode);
          this.shimanoActiveLanguageData = activeLanguage.language;
          this.shimanoActiveLanguageCountryIsocode = activeLanguage.language.country.isocode;
          this.shimanoActiveLanguageIsocode = activeLanguage.language.isocode;
          return this.languageExtendService.getAvailableLanguages();
        })
      )
      .subscribe((availableLanguages) => {
        this.availableLanguages = availableLanguages.languages;
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });
  }
}
